// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AthenaLink-module__font-s-10___bUB3F {
  font-size: 10px !important;
}

.AthenaLink-module__font-s-12___BmUU9 {
  font-size: 12px !important;
}

.AthenaLink-module__font-s-13___KOR3M {
  font-size: 13px !important;
}

.AthenaLink-module__font-s-14___puQVS {
  font-size: 14px !important;
}

.AthenaLink-module__font-s-15___cN6IX {
  font-size: 15px !important;
}

.AthenaLink-module__font-s-16___BD89R {
  font-size: 16px !important;
}

.AthenaLink-module__font-s-18___knKgb {
  font-size: 18px !important;
}

.AthenaLink-module__font-s-20___Npc0F {
  font-size: 20px !important;
}

.AthenaLink-module__font-s-22___NwTt3 {
  font-size: 22px !important;
}

.AthenaLink-module__font-s-28___XalSm {
  font-size: 28px !important;
}

.AthenaLink-module__font-w-400___Dj4Da {
  font-weight: 400 !important;
}

.AthenaLink-module__font-w-500___Ber4c {
  font-weight: 500 !important;
}

.AthenaLink-module__font-w-600___q14Uj {
  font-weight: 600 !important;
}

.AthenaLink-module__font-w-700___SjP0o {
  font-weight: 700 !important;
}

.AthenaLink-module__p-5___IYDFz {
  padding: 5px !important;
}

.AthenaLink-module__p-12___peTPa {
  padding: 12px !important;
}

.AthenaLink-module__p-16___OxXGz {
  padding: 16px !important;
}

.AthenaLink-module__p-30___Peq7C {
  padding: 30px !important;
}

.AthenaLink-module__p-b-0___uisUb {
  padding-bottom: 0 !important;
}

.AthenaLink-module__p-b-5___DrM3Y {
  padding-bottom: 5px !important;
}

.AthenaLink-module__p-b-10___BQMNS {
  padding-bottom: 10px !important;
}

.AthenaLink-module__p-b-12___g1jKx {
  padding-bottom: 12px !important;
}

.AthenaLink-module__p-b-16___ccx7K {
  padding-bottom: 16px !important;
}

.AthenaLink-module__p-b-18___Bsm3j {
  padding-bottom: 18px !important;
}

.AthenaLink-module__p-b-20___PrdhF {
  padding-bottom: 20px !important;
}

.AthenaLink-module__p-b-25___qRdBF {
  padding-bottom: 25px !important;
}

.AthenaLink-module__p-b-30___JZc2L {
  padding-bottom: 30px !important;
}

.AthenaLink-module__p-b-50___hKx8c {
  padding-bottom: 50px !important;
}

.AthenaLink-module__p-t-0___EwNCl {
  padding-top: 0 !important;
}

.AthenaLink-module__p-t-12___t64gR {
  padding-top: 12px !important;
}

.AthenaLink-module__p-t-16___P3gnO {
  padding-top: 16px !important;
}

.AthenaLink-module__p-t-18___gQTGM {
  padding-top: 18px !important;
}

.AthenaLink-module__p-t-20___mtGmb {
  padding-top: 20px !important;
}

.AthenaLink-module__p-t-30___La_QL {
  padding-top: 30px !important;
}

.AthenaLink-module__p-t-40___w2iU8 {
  padding-top: 40px !important;
}

.AthenaLink-module__p-t-50___AGyWl {
  padding-top: 50px !important;
}

.AthenaLink-module__p-l-20___vctbW {
  padding-left: 20px !important;
}

.AthenaLink-module__p-l-30___yP7ou {
  padding-left: 30px !important;
}

.AthenaLink-module__p-l-40___XVQwh {
  padding-left: 40px !important;
}

.AthenaLink-module__p-r-16___plR1B {
  padding-right: 16px !important;
}

.AthenaLink-module__p-r-20___lidsn {
  padding-right: 20px !important;
}

.AthenaLink-module__p-r-30___yazvv {
  padding-right: 30px !important;
}

.AthenaLink-module__p-r-50___YOKGf {
  padding-right: 50px !important;
}

.AthenaLink-module__p-r-60___IQiaL {
  padding-right: 60px !important;
}

.AthenaLink-module__m-b-1___cDYlp {
  margin-bottom: 1px !important;
}

.AthenaLink-module__m-b-2___F7MdR {
  margin-bottom: 2px !important;
}

.AthenaLink-module__m-b-6___zfV5a {
  margin-bottom: 6px !important;
}

.AthenaLink-module__m-b-8___vwVcf {
  margin-bottom: 8px !important;
}

.AthenaLink-module__m-b-10___lqAA0 {
  margin-bottom: 10px !important;
}

.AthenaLink-module__m-b-14___YyuJ_ {
  margin-bottom: 14px !important;
}

.AthenaLink-module__m-b-16___a9J5G {
  margin-bottom: 16px !important;
}

.AthenaLink-module__m-b-20___yT093 {
  margin-bottom: 20px !important;
}

.AthenaLink-module__m-b-22___thADp {
  margin-bottom: 22px !important;
}

.AthenaLink-module__m-b-24___KWOV_ {
  margin-bottom: 24px !important;
}

.AthenaLink-module__m-b-30___cHMVH {
  margin-bottom: 30px !important;
}

.AthenaLink-module__m-b-32___yIHBb {
  margin-bottom: 32px !important;
}

.AthenaLink-module__m-b-40___hKNSk {
  margin-bottom: 40px !important;
}

.AthenaLink-module__m-t-2___phnEq {
  margin-top: 2px !important;
}

.AthenaLink-module__m-t-3___xkPJ5 {
  margin-top: 3px !important;
}

.AthenaLink-module__m-t-4___Y9f35 {
  margin-top: 4px !important;
}

.AthenaLink-module__m-t-5___fKb0q {
  margin-top: 5px !important;
}

.AthenaLink-module__m-t-8___uKfQL {
  margin-top: 8px !important;
}

.AthenaLink-module__m-t-10___hPCqJ {
  margin-top: 10px !important;
}

.AthenaLink-module__m-t-15___v3osC {
  margin-top: 15px !important;
}

.AthenaLink-module__m-t-16___aXAQD {
  margin-top: 16px !important;
}

.AthenaLink-module__m-t-20___RUJEu {
  margin-top: 20px !important;
}

.AthenaLink-module__m-t-22___BGuam {
  margin-top: 22px !important;
}

.AthenaLink-module__m-t-30___Buyr_ {
  margin-top: 30px !important;
}

.AthenaLink-module__m-t-32___BG2Ii {
  margin-top: 32px !important;
}

.AthenaLink-module__m-l-auto____eQf1 {
  margin-left: auto !important;
}

.AthenaLink-module__m-l-4___exk9O {
  margin-left: 4px !important;
}

.AthenaLink-module__m-l-5___WutsM {
  margin-left: 5px !important;
}

.AthenaLink-module__m-l-6___rDw1W {
  margin-left: 6px !important;
}

.AthenaLink-module__m-l-8___faybJ {
  margin-left: 8px !important;
}

.AthenaLink-module__m-l-10___fP1QL {
  margin-left: 10px !important;
}

.AthenaLink-module__m-l-16___aRbrA {
  margin-left: 16px !important;
}

.AthenaLink-module__m-l-20___V3BIW {
  margin-left: 20px !important;
}

.AthenaLink-module__m-l-24___NEsw5 {
  margin-left: 24px !important;
}

.AthenaLink-module__m-l-30___fc0Ah {
  margin-left: 30px !important;
}

.AthenaLink-module__m-l-35___fKF7E {
  margin-left: 35px !important;
}

.AthenaLink-module__m-l-40___IQVuA {
  margin-left: 40px !important;
}

.AthenaLink-module__m-r-8___LCF9n {
  margin-right: 8px !important;
}

.AthenaLink-module__m-r-10___UHouD {
  margin-right: 10px !important;
}

.AthenaLink-module__m-r-16___VQrEK {
  margin-right: 16px !important;
}

.AthenaLink-module__m-r-20___YdIFq {
  margin-right: 20px !important;
}

.AthenaLink-module__m-r-24___P3ghP {
  margin-right: 24px !important;
}

.AthenaLink-module__m-r-30___diSU0 {
  margin-right: 30px !important;
}

.AthenaLink-module__m-r-40___SZroj {
  margin-right: 40px !important;
}

.AthenaLink-module__border-r-3___RED1v {
  border-radius: 3px !important;
}

.AthenaLink-module__border-r-4___paQ33 {
  border-radius: 4px !important;
}

.AthenaLink-module__border-r-6___OllFQ {
  border-radius: 6px !important;
}

.AthenaLink-module__border-r-10___OuEKT {
  border-radius: 10px !important;
}

.AthenaLink-module__border-r-12___NFCvx {
  border-radius: 12px !important;
}

.AthenaLink-module__border-r-16___em2PM {
  border-radius: 16px !important;
}

.AthenaLink-module__border-r-50___QWYOh {
  border-radius: 50% !important;
}

.AthenaLink-module__primary-border____EXsR {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.AthenaLink-module__primary-border-b___x6Jbb {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.AthenaLink-module__primary-border-t___LLo4z {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.AthenaLink-module__primary-border-l___fBmJF {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.AthenaLink-module__primary-border-r___kEJ6D {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.AthenaLink-module__secondary-border___Upecj {
  border: 1px solid #637768;
}

.AthenaLink-module__secondary-border-b___a98I9 {
  border-bottom: 1px solid #637768;
}

.AthenaLink-module__secondary-border-t___KVBYt {
  border-top: 1px solid #637768;
}

.AthenaLink-module__secondary-border-l___rGVgc {
  border-left: 1px solid #637768;
}

.AthenaLink-module__secondary-border-r___Il7kw {
  border-right: 1px solid #637768;
}

.AthenaLink-module__gap-0___APOPE {
  gap: 0 !important;
}

.AthenaLink-module__gap-2___WSNgM {
  gap: 2px !important;
}

.AthenaLink-module__gap-4___yBVv5 {
  gap: 4px !important;
}

.AthenaLink-module__gap-5___msiji {
  gap: 5px !important;
}

.AthenaLink-module__gap-6___ZEq3E {
  gap: 6px !important;
}

.AthenaLink-module__gap-8___FcOYM {
  gap: 8px !important;
}

.AthenaLink-module__gap-10___SJkx9 {
  gap: 10px !important;
}

.AthenaLink-module__gap-12___UrTzK {
  gap: 12px !important;
}

.AthenaLink-module__gap-14___SiA3r {
  gap: 14px !important;
}

.AthenaLink-module__gap-16___r4iXs {
  gap: 16px !important;
}

.AthenaLink-module__gap-18___NQPVs {
  gap: 18px !important;
}

.AthenaLink-module__gap-20___FQrtX {
  gap: 20px !important;
}

.AthenaLink-module__gap-24___GFpdF {
  gap: 24px !important;
}

.AthenaLink-module__gap-26___V5b6U {
  gap: 26px !important;
}

.AthenaLink-module__gap-30___Otc7b {
  gap: 30px !important;
}

.AthenaLink-module__gap-32___WR13s {
  gap: 32px !important;
}

.AthenaLink-module__gap-40___EhvEj {
  gap: 40px !important;
}

.AthenaLink-module__gap-50___BFjK4 {
  gap: 50px !important;
}

.AthenaLink-module__flex-1___hVQa1 {
  flex: 1;
}

.AthenaLink-module__flex-none___l0CK1 {
  flex: none !important;
}

.AthenaLink-module__flex-column___TrLp8 {
  display: flex;
  flex-direction: column !important;
}

.AthenaLink-module__flex-row___a2Ssd {
  display: flex;
  flex-direction: row !important;
}

.AthenaLink-module__vertically-centered____m7gZ {
  display: flex;
  align-items: center !important;
}

.AthenaLink-module__horizontally-centered___O3RyP {
  display: flex;
  justify-content: center !important;
}

.AthenaLink-module__horizontally-end___K05ML {
  display: flex;
  justify-content: end !important;
}

.AthenaLink-module__vertically-start___JiQWs {
  display: flex;
  align-items: start !important;
}

.AthenaLink-module__space-between___YJZma {
  display: flex;
  justify-content: space-between !important;
}

.AthenaLink-module__flex-wrap___TsMIJ {
  flex-wrap: wrap !important;
}

.AthenaLink-module__height-100___I1Z5S {
  height: 100%;
}

.AthenaLink-module__width-50___Jug1z {
  width: 50% !important;
}

.AthenaLink-module__width-100___nQJUC {
  width: 100%;
}

.AthenaLink-module__cursor-pointer___LHgcf {
  cursor: pointer;
}

.AthenaLink-module__cursor-not-allowed___PRXVg {
  cursor: not-allowed !important;
}

.AthenaLink-module__absolute-centered___ikozJ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.AthenaLink-module__absolute___P6aaF {
  position: absolute;
}

.AthenaLink-module__relative___CYLGu {
  position: relative;
}

.AthenaLink-module__fixed___UG8TR {
  position: fixed;
}

.AthenaLink-module__visible___mhW5v {
  opacity: 1;
}

.AthenaLink-module__invisible___mpfUa {
  opacity: 0;
}

.AthenaLink-module__col-90___CuhvZ {
  width: 90% !important;
}

.AthenaLink-module__col-auto___vmu__ {
  width: auto !important;
}

.AthenaLink-module__medical-tabs___mFFVv {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.AthenaLink-module__medical-table-new___aBOSM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AthenaLink-module__medical-table-new___aBOSM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AthenaLink-module__medical-table-new___aBOSM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AthenaLink-module__medical-table-new___aBOSM::-webkit-scrollbar-track {
  display: none;
}
.AthenaLink-module__medical-table-new___aBOSM.AthenaLink-module__no-pagination___uCLGN {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AthenaLink-module__medical-table-new___aBOSM.AthenaLink-module__no-pagination___uCLGN:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AthenaLink-module__medical-table-new___aBOSM.AthenaLink-module__no-pagination___uCLGN::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AthenaLink-module__medical-table-new___aBOSM.AthenaLink-module__no-pagination___uCLGN::-webkit-scrollbar-track {
  display: none;
}

.AthenaLink-module__medical-table-empty___kJUib {
  padding: 14px 40px !important;
}

.AthenaLink-module__icon-btn___kOaBQ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.AthenaLink-module__search-icon___r7Aod {
  width: 24px;
  height: 24px;
  align-self: center;
}

.AthenaLink-module__disable-select___KaQhB {
  user-select: none;
}

.AthenaLink-module__break-word___EC7Nr {
  word-break: break-word;
}

.AthenaLink-module__popup-clear-btn___fBFDR {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.AthenaLink-module__scroll-m-b-20___FOqQx {
  scroll-margin-bottom: 20px;
}

.AthenaLink-module__link____kAdW {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  text-decoration: none;
  color: #18181b;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background-color 0.15s;
}

.AthenaLink-module__link____kAdW:hover {
  border-color: #a1a1aa;
}

.AthenaLink-module__link____kAdW:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.AthenaLink-module__disabled___H6FWM {
  cursor: default;
  opacity: 0.7;
}

.AthenaLink-module__disabled___H6FWM:hover {
  border-color: #e4e4e7;
}

.AthenaLink-module__badge___CpGeY {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #18181b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.AthenaLink-module__badgeText___c4ukC {
  font-size: 10px;
  font-weight: 700;
  color: #fafafa;
  font-family: "IBM Plex Mono", monospace;
}

.AthenaLink-module__meta___fOJqF {
  flex: 1;
}

.AthenaLink-module__title___lpg0N {
  font-size: 11px;
  font-weight: 600;
}

.AthenaLink-module__mrn___lLBuN {
  font-size: 10px;
  color: #a1a1aa;
  margin-left: 6px;
  font-family: "IBM Plex Mono", monospace;
}

.AthenaLink-module__arrow___h35dK {
  font-size: 13px;
  color: #a1a1aa;
}

.AthenaLink-module__line___mizQR {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #18181b;
  text-decoration: underline;
  text-decoration-color: #d4d4d8;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.AthenaLink-module__line___mizQR:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}
.AthenaLink-module__line___mizQR {
  outline: none;
}
.AthenaLink-module__line___mizQR:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.AthenaLink-module__line___mizQR:disabled, .AthenaLink-module__line___mizQR[aria-disabled=true] {
  color: #a1a1aa;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/AthenaLink/AthenaLink.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mEAAA;AA8pBF;;AA3pBA;EACE,qBAAA;AA8pBF;;AA3pBA;EACE,0BAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,qBAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;AA8pBF;;AA3pBA;EACE,OAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,cAAA;AA8pBF;;AA3pBA;EEzBE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,sDAAA;AFwrBF;AEtrBE;EACE,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AFwrBJ;AArrBA;EElCE,aAAA;AF0tBF;AExtBE;EACE,0BAAA;EACA,mBALuB;AF+tB3B;AE1rBE;EAEE,cAAA;EACA,eAAA;AF2rBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  text-decoration: none;\n  color: #18181b;\n  cursor: pointer;\n  transition: border-color 0.15s, color 0.15s, background-color 0.15s;\n}\n\n.link:hover {\n  border-color: #a1a1aa;\n}\n\n.link:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n\n.disabled:hover {\n  border-color: #e4e4e7;\n}\n\n.badge {\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  background: #18181b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.badgeText {\n  font-size: 10px;\n  font-weight: 700;\n  color: #fafafa;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.meta {\n  flex: 1;\n}\n\n.title {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.mrn {\n  font-size: 10px;\n  color: #a1a1aa;\n  margin-left: 6px;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.arrow {\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.line {\n  @include line-button;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `AthenaLink-module__font-s-10___bUB3F`,
	"fontS12": `AthenaLink-module__font-s-12___BmUU9`,
	"fontS13": `AthenaLink-module__font-s-13___KOR3M`,
	"fontS14": `AthenaLink-module__font-s-14___puQVS`,
	"fontS15": `AthenaLink-module__font-s-15___cN6IX`,
	"fontS16": `AthenaLink-module__font-s-16___BD89R`,
	"fontS18": `AthenaLink-module__font-s-18___knKgb`,
	"fontS20": `AthenaLink-module__font-s-20___Npc0F`,
	"fontS22": `AthenaLink-module__font-s-22___NwTt3`,
	"fontS28": `AthenaLink-module__font-s-28___XalSm`,
	"fontW400": `AthenaLink-module__font-w-400___Dj4Da`,
	"fontW500": `AthenaLink-module__font-w-500___Ber4c`,
	"fontW600": `AthenaLink-module__font-w-600___q14Uj`,
	"fontW700": `AthenaLink-module__font-w-700___SjP0o`,
	"p5": `AthenaLink-module__p-5___IYDFz`,
	"p12": `AthenaLink-module__p-12___peTPa`,
	"p16": `AthenaLink-module__p-16___OxXGz`,
	"p30": `AthenaLink-module__p-30___Peq7C`,
	"pB0": `AthenaLink-module__p-b-0___uisUb`,
	"pB5": `AthenaLink-module__p-b-5___DrM3Y`,
	"pB10": `AthenaLink-module__p-b-10___BQMNS`,
	"pB12": `AthenaLink-module__p-b-12___g1jKx`,
	"pB16": `AthenaLink-module__p-b-16___ccx7K`,
	"pB18": `AthenaLink-module__p-b-18___Bsm3j`,
	"pB20": `AthenaLink-module__p-b-20___PrdhF`,
	"pB25": `AthenaLink-module__p-b-25___qRdBF`,
	"pB30": `AthenaLink-module__p-b-30___JZc2L`,
	"pB50": `AthenaLink-module__p-b-50___hKx8c`,
	"pT0": `AthenaLink-module__p-t-0___EwNCl`,
	"pT12": `AthenaLink-module__p-t-12___t64gR`,
	"pT16": `AthenaLink-module__p-t-16___P3gnO`,
	"pT18": `AthenaLink-module__p-t-18___gQTGM`,
	"pT20": `AthenaLink-module__p-t-20___mtGmb`,
	"pT30": `AthenaLink-module__p-t-30___La_QL`,
	"pT40": `AthenaLink-module__p-t-40___w2iU8`,
	"pT50": `AthenaLink-module__p-t-50___AGyWl`,
	"pL20": `AthenaLink-module__p-l-20___vctbW`,
	"pL30": `AthenaLink-module__p-l-30___yP7ou`,
	"pL40": `AthenaLink-module__p-l-40___XVQwh`,
	"pR16": `AthenaLink-module__p-r-16___plR1B`,
	"pR20": `AthenaLink-module__p-r-20___lidsn`,
	"pR30": `AthenaLink-module__p-r-30___yazvv`,
	"pR50": `AthenaLink-module__p-r-50___YOKGf`,
	"pR60": `AthenaLink-module__p-r-60___IQiaL`,
	"mB1": `AthenaLink-module__m-b-1___cDYlp`,
	"mB2": `AthenaLink-module__m-b-2___F7MdR`,
	"mB6": `AthenaLink-module__m-b-6___zfV5a`,
	"mB8": `AthenaLink-module__m-b-8___vwVcf`,
	"mB10": `AthenaLink-module__m-b-10___lqAA0`,
	"mB14": `AthenaLink-module__m-b-14___YyuJ_`,
	"mB16": `AthenaLink-module__m-b-16___a9J5G`,
	"mB20": `AthenaLink-module__m-b-20___yT093`,
	"mB22": `AthenaLink-module__m-b-22___thADp`,
	"mB24": `AthenaLink-module__m-b-24___KWOV_`,
	"mB30": `AthenaLink-module__m-b-30___cHMVH`,
	"mB32": `AthenaLink-module__m-b-32___yIHBb`,
	"mB40": `AthenaLink-module__m-b-40___hKNSk`,
	"mT2": `AthenaLink-module__m-t-2___phnEq`,
	"mT3": `AthenaLink-module__m-t-3___xkPJ5`,
	"mT4": `AthenaLink-module__m-t-4___Y9f35`,
	"mT5": `AthenaLink-module__m-t-5___fKb0q`,
	"mT8": `AthenaLink-module__m-t-8___uKfQL`,
	"mT10": `AthenaLink-module__m-t-10___hPCqJ`,
	"mT15": `AthenaLink-module__m-t-15___v3osC`,
	"mT16": `AthenaLink-module__m-t-16___aXAQD`,
	"mT20": `AthenaLink-module__m-t-20___RUJEu`,
	"mT22": `AthenaLink-module__m-t-22___BGuam`,
	"mT30": `AthenaLink-module__m-t-30___Buyr_`,
	"mT32": `AthenaLink-module__m-t-32___BG2Ii`,
	"mLAuto": `AthenaLink-module__m-l-auto____eQf1`,
	"mL4": `AthenaLink-module__m-l-4___exk9O`,
	"mL5": `AthenaLink-module__m-l-5___WutsM`,
	"mL6": `AthenaLink-module__m-l-6___rDw1W`,
	"mL8": `AthenaLink-module__m-l-8___faybJ`,
	"mL10": `AthenaLink-module__m-l-10___fP1QL`,
	"mL16": `AthenaLink-module__m-l-16___aRbrA`,
	"mL20": `AthenaLink-module__m-l-20___V3BIW`,
	"mL24": `AthenaLink-module__m-l-24___NEsw5`,
	"mL30": `AthenaLink-module__m-l-30___fc0Ah`,
	"mL35": `AthenaLink-module__m-l-35___fKF7E`,
	"mL40": `AthenaLink-module__m-l-40___IQVuA`,
	"mR8": `AthenaLink-module__m-r-8___LCF9n`,
	"mR10": `AthenaLink-module__m-r-10___UHouD`,
	"mR16": `AthenaLink-module__m-r-16___VQrEK`,
	"mR20": `AthenaLink-module__m-r-20___YdIFq`,
	"mR24": `AthenaLink-module__m-r-24___P3ghP`,
	"mR30": `AthenaLink-module__m-r-30___diSU0`,
	"mR40": `AthenaLink-module__m-r-40___SZroj`,
	"borderR3": `AthenaLink-module__border-r-3___RED1v`,
	"borderR4": `AthenaLink-module__border-r-4___paQ33`,
	"borderR6": `AthenaLink-module__border-r-6___OllFQ`,
	"borderR10": `AthenaLink-module__border-r-10___OuEKT`,
	"borderR12": `AthenaLink-module__border-r-12___NFCvx`,
	"borderR16": `AthenaLink-module__border-r-16___em2PM`,
	"borderR50": `AthenaLink-module__border-r-50___QWYOh`,
	"primaryBorder": `AthenaLink-module__primary-border____EXsR`,
	"primaryBorderB": `AthenaLink-module__primary-border-b___x6Jbb`,
	"primaryBorderT": `AthenaLink-module__primary-border-t___LLo4z`,
	"primaryBorderL": `AthenaLink-module__primary-border-l___fBmJF`,
	"primaryBorderR": `AthenaLink-module__primary-border-r___kEJ6D`,
	"secondaryBorder": `AthenaLink-module__secondary-border___Upecj`,
	"secondaryBorderB": `AthenaLink-module__secondary-border-b___a98I9`,
	"secondaryBorderT": `AthenaLink-module__secondary-border-t___KVBYt`,
	"secondaryBorderL": `AthenaLink-module__secondary-border-l___rGVgc`,
	"secondaryBorderR": `AthenaLink-module__secondary-border-r___Il7kw`,
	"gap0": `AthenaLink-module__gap-0___APOPE`,
	"gap2": `AthenaLink-module__gap-2___WSNgM`,
	"gap4": `AthenaLink-module__gap-4___yBVv5`,
	"gap5": `AthenaLink-module__gap-5___msiji`,
	"gap6": `AthenaLink-module__gap-6___ZEq3E`,
	"gap8": `AthenaLink-module__gap-8___FcOYM`,
	"gap10": `AthenaLink-module__gap-10___SJkx9`,
	"gap12": `AthenaLink-module__gap-12___UrTzK`,
	"gap14": `AthenaLink-module__gap-14___SiA3r`,
	"gap16": `AthenaLink-module__gap-16___r4iXs`,
	"gap18": `AthenaLink-module__gap-18___NQPVs`,
	"gap20": `AthenaLink-module__gap-20___FQrtX`,
	"gap24": `AthenaLink-module__gap-24___GFpdF`,
	"gap26": `AthenaLink-module__gap-26___V5b6U`,
	"gap30": `AthenaLink-module__gap-30___Otc7b`,
	"gap32": `AthenaLink-module__gap-32___WR13s`,
	"gap40": `AthenaLink-module__gap-40___EhvEj`,
	"gap50": `AthenaLink-module__gap-50___BFjK4`,
	"flex1": `AthenaLink-module__flex-1___hVQa1`,
	"flexNone": `AthenaLink-module__flex-none___l0CK1`,
	"flexColumn": `AthenaLink-module__flex-column___TrLp8`,
	"flexRow": `AthenaLink-module__flex-row___a2Ssd`,
	"verticallyCentered": `AthenaLink-module__vertically-centered____m7gZ`,
	"horizontallyCentered": `AthenaLink-module__horizontally-centered___O3RyP`,
	"horizontallyEnd": `AthenaLink-module__horizontally-end___K05ML`,
	"verticallyStart": `AthenaLink-module__vertically-start___JiQWs`,
	"spaceBetween": `AthenaLink-module__space-between___YJZma`,
	"flexWrap": `AthenaLink-module__flex-wrap___TsMIJ`,
	"height100": `AthenaLink-module__height-100___I1Z5S`,
	"width50": `AthenaLink-module__width-50___Jug1z`,
	"width100": `AthenaLink-module__width-100___nQJUC`,
	"cursorPointer": `AthenaLink-module__cursor-pointer___LHgcf`,
	"cursorNotAllowed": `AthenaLink-module__cursor-not-allowed___PRXVg`,
	"absoluteCentered": `AthenaLink-module__absolute-centered___ikozJ`,
	"absolute": `AthenaLink-module__absolute___P6aaF`,
	"relative": `AthenaLink-module__relative___CYLGu`,
	"fixed": `AthenaLink-module__fixed___UG8TR`,
	"visible": `AthenaLink-module__visible___mhW5v`,
	"invisible": `AthenaLink-module__invisible___mpfUa`,
	"col90": `AthenaLink-module__col-90___CuhvZ`,
	"colAuto": `AthenaLink-module__col-auto___vmu__`,
	"medicalTabs": `AthenaLink-module__medical-tabs___mFFVv`,
	"medicalTableNew": `AthenaLink-module__medical-table-new___aBOSM`,
	"noPagination": `AthenaLink-module__no-pagination___uCLGN`,
	"medicalTableEmpty": `AthenaLink-module__medical-table-empty___kJUib`,
	"iconBtn": `AthenaLink-module__icon-btn___kOaBQ`,
	"searchIcon": `AthenaLink-module__search-icon___r7Aod`,
	"disableSelect": `AthenaLink-module__disable-select___KaQhB`,
	"breakWord": `AthenaLink-module__break-word___EC7Nr`,
	"popupClearBtn": `AthenaLink-module__popup-clear-btn___fBFDR`,
	"scrollMB20": `AthenaLink-module__scroll-m-b-20___FOqQx`,
	"link": `AthenaLink-module__link____kAdW`,
	"disabled": `AthenaLink-module__disabled___H6FWM`,
	"badge": `AthenaLink-module__badge___CpGeY`,
	"badgeText": `AthenaLink-module__badgeText___c4ukC`,
	"meta": `AthenaLink-module__meta___fOJqF`,
	"title": `AthenaLink-module__title___lpg0N`,
	"mrn": `AthenaLink-module__mrn___lLBuN`,
	"arrow": `AthenaLink-module__arrow___h35dK`,
	"line": `AthenaLink-module__line___mizQR`
};
module.exports = ___CSS_LOADER_EXPORT___;
